// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1c5z9","amount":"Amount_amount__1eW2q","tip":"Amount_tip__17zEF","tipHeader":"Amount_tipHeader__3Nkz0","tipsWrap":"Amount_tipsWrap__13bHo"};